var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.7px",
    height: "30px",
    viewBox: "0 0 148 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#393185",
    strokeWidth: 9,
    d: "M111 48c-6,0 -10,-5 -10,-11l0 -21 31 32 -21 0 0 0zm-5 53l-64 0c-3,0 -5,-3 -5,-6 0,-3 2,-5 5,-5l64 0c3,0 5,2 5,5 0,3 -2,6 -5,6l0 0zm0 32l-64 0c-3,0 -5,-3 -5,-6 0,-3 2,-5 5,-5l64 0c3,0 5,2 5,5 0,3 -2,6 -5,6l0 0zm-5 -128c-1,0 -75,0 -75,0 -12,0 -21,10 -21,21l0 128c0,11 9,21 21,21l96 0c11,0 21,-10 21,-21l0 -106 -42 -43 0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d4263a75261648bc2de78b750692fa01.svg";
export { ForwardRef as ReactComponent };